// Small DOM-driven entry point. A disabled feature has no component to upgrade.
const manifest = JSON.parse(document.getElementById('VelmoraModules')?.textContent || '{}');
const loaded = new Map();
const load = name => {
  if (!manifest[name]) return Promise.resolve();
  if (!loaded.has(name)) loaded.set(name, import(manifest[name]).catch(error => {
    loaded.delete(name);
    if (name === 'menu') document.documentElement.classList.add('dd-menu-load-failed');
    if (name === 'facets') document.documentElement.classList.add('dd-facets-load-failed');
    if (name === 'gallery') document.querySelectorAll('.dd-filter').forEach(filter=>{filter.dataset.ddInitialized='true';});
    document.dispatchEvent(new CustomEvent('dd:module:error', { detail: { name } }));
    throw error;
  }));
  return loaded.get(name);
};
const definitions = [
  ['menu', 'dd-menu-drawer'], ['header', 'dd-header'], ['cart', 'dd-cart-drawer,dd-product-form'],
  ['product', 'dd-product'], ['gallery', 'dd-product,[data-dd-quantity-step],[data-dd-grid-view],.dd-filter-sidebar .dd-filter'],
  ['nativeOrder', '[data-cb-order-open]'],
  ['wishlist', '[data-dd-wishlist-open],[data-dd-wishlist-product]'],
  ['features', '[data-dd-hotspots],[data-dd-before-after],[data-dd-sticky-cart]'],
  ['search', 'predictive-search'], ['recommendations', 'product-recommendations'],
  ['editorial', 'dd-newsletter-popup,dd-lazy-video,dd-image-gallery,dd-shop-look,dd-table-expand,dd-ticker'],
  ['carousel', 'dd-carousel,dd-slideshow'], ['storytelling', 'dd-scrolling-story,dd-revealed-image'], ['facets', 'dd-facets']
];
function scan() {
  for (const [name, selector] of definitions) if (document.querySelector(selector)) load(name).catch(() => {});
  if (document.body.dataset.ddAnimations !== 'false' && (document.querySelector('[data-dd-motion]:not([data-dd-motion="none"])') || document.body.dataset.ddPageTransition === 'true')) load('motion').catch(() => {});
  document.dispatchEvent(new CustomEvent('dd:content:ready'));
}
let scheduled = false;
const observer = new MutationObserver(records => {
  if (scheduled || !records.some(record => record.type === 'attributes' || [...record.addedNodes].some(node => node.nodeType === 1))) return;
  scheduled = true;
  queueMicrotask(() => { scheduled = false; scan(); });
});
observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-dd-animations', 'data-dd-page-transition'] });
document.addEventListener('shopify:section:load', scan);
let quickCss;
function loadQuickCss() {
  if (quickCss) return quickCss;
  quickCss = new Promise((resolve, reject) => {
    const sheet = document.createElement('link');
    sheet.rel = 'stylesheet'; sheet.href = manifest.quickCss;
    sheet.onload = resolve;
    sheet.onerror = () => { sheet.remove(); quickCss = null; reject(new Error('Styles unavailable')); };
    document.head.append(sheet);
  });
  return quickCss;
}
let quickRequest = 0;
let quickReady = false;
document.addEventListener('keydown', event => { if (event.key === 'Escape') quickRequest++; }, true);
document.addEventListener('click', async event => {
  const link = event.target.closest('a[data-dd-quick-mode]');
  if (!link || (quickReady && customElements.get('dd-quick-product')) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (url.origin !== location.origin) return;
  if (typeof document.querySelector('dd-quick-product dialog')?.showModal !== 'function') return;
  event.preventDefault(); event.stopImmediatePropagation();
  const request = ++quickRequest;
  link.setAttribute('aria-busy', 'true');
  try {
    await Promise.all([loadQuickCss(), load('quick'), load('product'), load('cart'), load('gallery')]);
    // Defining the component can finish before its stylesheet or purchase modules.
    // Keep intercepting clicks until the complete surface is ready.
    quickReady = true;
    if (request === quickRequest && link.isConnected) document.querySelector('dd-quick-product')?.open(link, url);
  } catch { if (request === quickRequest) location.assign(url.href); }
  finally { link.removeAttribute('aria-busy'); }
}, true);
scan();
